var _defs, _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconOuvertureModal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_2736",
    "data-name": "Groupe 2736",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #ebbc02;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_136",
    "data-name": "Ellipse 136",
    className: "cls-1",
    cx: 21,
    cy: 21,
    r: 21
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_weather-direction-up-right",
    "data-name": "Icon weather-direction-up-right",
    className: "cls-2",
    d: "M12.06,24.739a1.668,1.668,0,0,0,.419,1.178,1.761,1.761,0,0,0,1.275.452,1.556,1.556,0,0,0,1.178-.452l9.745-9.761V19.3A1.654,1.654,0,0,0,26.37,21a1.584,1.584,0,0,0,1.194-.5,1.668,1.668,0,0,0,.484-1.21V12.074A1.654,1.654,0,0,0,26.37,10.38H19.11a1.569,1.569,0,0,0-1.178.484,1.667,1.667,0,0,0-.468,1.21A1.6,1.6,0,0,0,19.11,13.72h3.146L12.479,23.5A1.927,1.927,0,0,0,12.06,24.739Z",
    transform: "translate(1.133 2.813)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOuvertureModal);
export default __webpack_public_path__ + "static/media/icon_ouverture_modal.221dfd1b5170643fd364380adcd24762.svg";
export { ForwardRef as ReactComponent };